module.exports = __webpack_public_path__ + "static/img/timg.5b15117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/timg.png
// module id = 102
// module chunks = 12